export const SET_DOMAIN_LIST = 'Company//SET_DOMAIN_LIST'



// WEBPACK FOOTER //
// ./src/app/company/vuex/mutations-types.js